import FuseAnimate from "../fuse-animate/fuse-animate";
import {Card, CircularProgress, Hidden} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import * as toast from "../../utils/toast";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import {PhoneAndroid} from "@material-ui/icons";
import {useStore} from "../../store";
import {useSnackbar} from "notistack";
import {EndpointService} from "../../services";
import {clearEndpoint, fetchAccount, invalidateAccount} from "../../store/actions";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
    },
    header: {
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
    },
    deviceRow: {
        display: 'flex',
        flexDirection: 'row',
        paddingTop:  4,
        paddingLeft: 8,
        textTransform: 'capitalize',
    },
    linkButton: {
        marginTop: 24,
    },
    sideLinkButton: {
        minWidth: 180,
    },
}));

const EndpointCard = ({ endpoint , animation, delay }) => {
    const classes = useStyles();
    const [state, setState] = useState({fetching: false, isLoaded: true, reload: false})
    const [store, dispatch] = useStore();
    const {enqueueSnackbar, closeSnackbar} = useSnackbar();     // Snackbar Hook for notifications

    // Make sure the account is available in the store and reload it if state.reload changes
    useEffect(()=> {
        if (store.user.accountId) {
            dispatch(fetchAccount(store.user.accountId, store, dispatch))
        }
    }, [store.user.accountId, store, dispatch, state.reload])

    const deactivateEndpoint = (event) => {
        setState({...state, fetching: true})
        EndpointService.deactivate(endpoint.accountId, endpoint.id)
            .then((result) =>   {

                // Invalidate the store because services will have changed
                dispatch(invalidateAccount())

                // remove the deactivated endpoint
                dispatch(clearEndpoint());

                setState({...state, fetching: false, reload: true})

                // notify the user we succeeded
                toast.success("Your Receiver app has been deactivated", enqueueSnackbar, closeSnackbar)
            })
            .catch(error => {
                // notify the user we hit an error
                setState({...state, fetching: false})
                toast.apiError("Your Receiver app could not be deactivated", error, enqueueSnackbar)
            })
    }

    return (
        <FuseAnimate animation={animation} delay={delay}>
            <Card id="endpoint-card" className={classes.root}>
                <Typography variant="h6" color="secondary">Receiver App</Typography>

                <Grid container className="py-4" direction="row" justify="space-between" alignItems="center">

                    <Grid item className="font-light text-base">
                        <div className={classes.deviceRow} >
                            <PhoneAndroid color="action"/>
                            <Typography  variant="body1" className="pl-1">
                                {endpoint.deviceMake} {endpoint.deviceName} <span className="text-gray-400">&nbsp;&nbsp;[{endpoint.deviceOS} {endpoint.deviceOSVersion}]</span>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item >
                        <Hidden smDown>
                                <Button variant="outlined"
                                        color="primary"
                                        onClick={deactivateEndpoint}
                                        disabled={state.fetching}
                                        className={classes.sideLinkButton}>
                                    {state.fetching ?
                                        <CircularProgress size={18} className="m-1"/>
                                        :
                                        <>Deactivate</>
                                    }
                                </Button>
                        </Hidden>
                    </Grid>

                </Grid>
                <Hidden mdUp>
                    <Button variant="outlined"
                            color="primary"
                            className={classes.linkButton}
                    >Deactivate</Button>
                </Hidden>

            </Card>
        </FuseAnimate>
    )
}

export default EndpointCard;